import OverlayBase from "../overlay/OverlayBase";
import {useState} from "react";
import SvgLoader from "../../../svg/SvgLoader";
import {rpc_kickPlayer} from "../rpc";
import {useSocket} from "../SocketContext";

export default function KickOverlay(props: { playerName: string, playerSteamId: string, playerIp?: string, hide: () => void }){

    const [loading, setLoading] = useState<boolean>(false)
    const [reason, setReason] = useState<string>("")

    const [error, setError] = useState<string>("")
    const [validationError, setValidationError] = useState<string>("")

    const socket = useSocket()

    const handleBan = async () => {
        if (loading){
            return
        }
        setError("")
        setValidationError("")
        if (!reason || !reason.trim()) {
            setValidationError("Reason is required.")
            return
        }
        setLoading(true)

        const result = await rpc_kickPlayer(socket, props.playerSteamId, reason)

        // Alt method
        // const response = await doFetch(`/api/client/players/kick?serverId=${serverId}`, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type" : "application/json"
        //     },
        //     body: JSON.stringify({
        //         steamId: props.playerSteamId,
        //         reason: reason,
        //     })
        // })

        setLoading(false)

        if (result.success){
            props.hide()
        }
        else{
            let err = `Error: ${result.message ?? "Unknown error (-1)"}`
            if (result.message === "server_not_connected"){
                err = `The game server is not connected to RustServerTool (${err})`
            }
            else if (result.message === "server_timeout"){
                err = `The player is not connected or game server did not respond in time (${err})`
            }
            setError(err);
        }

        // if (response.ok){
        //     props.hide()
        // }
        // else{
        //     let err = response.error ?? "Unknown error (-1)"
        //
        //     console.log(response.code)
        //     // Bad Gateway i.e. server not connected
        //     if (response.code === 502){
        //         err = `The game server is not connected to RustServerTool (${err})`
        //     }
        //     // Gateway timeout -> request timed out
        //     else if (response.code === 504){
        //         err = `The game server did not respond in time (${err})`
        //     }
        //
        //     setError(err);
        // }
    };

    return (
        <OverlayBase hide={props.hide} w="w-[28rem]">
            <h2 className="text-xl font-semibold mb-4">Kick '{props.playerName}'</h2>
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium">Reason</label>
                    <input
                        type="text"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Enter reason for kick"
                        className="w-full p-2 border rounded-lg text-neutral-800"
                    />
                    {validationError && <p className="text-red-500 text-sm mt-1">{validationError}</p>}
                </div>
            </div>
            <div className="mt-6 flex flex-col items-end">
                {error && <p className="text-red-500 text-sm mb-2 text-right">{error}</p>}
                <div className="flex justify-end gap-3">
                    <button onClick={props.hide}
                            className="px-4 py-2 hover:bg-neutral-700 border border-neutral-500 rounded-lg">Cancel
                    </button>
                    <button onClick={handleBan} disabled={loading}
                            className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg disabled:bg-neutral-600 flex items-center">
                        {loading ? <SvgLoader className="size-5 text-transparent fill-white text-neutral-700 animate-spin inline" /> : "Kick"}
                    </button>
                </div>
            </div>
        </OverlayBase>
    )
}